import React, { useState, useEffect } from 'react'

import { useDispatch,useSelector } from 'react-redux';

import PoEditFormImplFormOnly from './PoEditFormImplFormOnly';
import UploadPoActionImpl from './action/uploadPo/UploadPoActionImpl';

export default function PoEditForm(){
    const [poCreated, setPOcreated] = useState(false);
    const {poObj} = useSelector((state)=>state.pharmaslice.poDashboard);
    return (
    <>
        <PoEditFormImplFormOnly/>
    </>
    );
};